import React, { createContext, useContext } from "react"
import { html } from "./utils/htm"

const initialValue = html`
  <value>
    <document></document>
  </value>
`

const EditorContext = createContext(() => {})
const ValueContext = createContext(initialValue)

// Hooks
export const useEditor = function() {
  return useContext(EditorContext)
}

export const useValue = function() {
  return useContext(ValueContext)
}

export default ({ children, editor, value }) => (
  <EditorContext.Provider value={editor}>
    <ValueContext.Provider value={value}>{children}</ValueContext.Provider>
  </EditorContext.Provider>
)
